export default {
  auth: () => import("/opt/render/project/src/.app/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/opt/render/project/src/.app/layouts/default.vue").then(m => m.default || m),
  map: () => import("/opt/render/project/src/.app/layouts/map.vue").then(m => m.default || m),
  sidebar: () => import("/opt/render/project/src/layers/tairo-layout-sidebar/layouts/sidebar.vue").then(m => m.default || m),
  collapse: () => import("/opt/render/project/src/layers/tairo-layout-collapse/layouts/collapse.vue").then(m => m.default || m),
  empty: () => import("/opt/render/project/src/layers/tairo/layouts/empty.vue").then(m => m.default || m)
}